import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutAdmin, signin, updateAdminPassword, updateProfile } from "../../api/authApis";

export const updateAdminPasswordAction = createAsyncThunk(
  "admin/updatePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await updateAdminPassword(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Password update failed");
    }
  }
);

export const updateProfileAction = createAsyncThunk(
  "user/updateProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await updateProfile(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Update failed");
    }
  }
);

export const loginAction = createAsyncThunk(
  "user/login",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await signin(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const logoutAction = createAsyncThunk(
  "admin/logout",
  async (_, { rejectWithValue }) => {
    try {
      const data = await logoutAdmin();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Logout failed");
    }
  }
);
